import { render, staticRenderFns } from "./Funnels.vue?vue&type=template&id=1d47cf06&scoped=true&"
import script from "./Funnels.vue?vue&type=script&lang=ts&"
export * from "./Funnels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47cf06",
  null
  
)

export default component.exports